import InstructorCard from './InstructorCard';
import { instructor_list } from './instructor_list';

const Instructors = () => {
  return (
    <section id='instructors' className='committee'>
        <h2>Eğitmenler</h2>
        <div className="cards">
            {
                instructor_list.map((instructor, index) => (
                    <InstructorCard
                        key={`instructor_${index}`}
                        name={instructor.name}
                        title={instructor.title}
                        image = {instructor.image}
                        url = {instructor.url}
                    /> 
                ))
            }
            {/* <InstructorCard name={"Mustafa SÖZBİLİR"} title={"Prof. Dr."}/> */}
            {/* <InstructorCard name={"Osman DURDAĞ"} title={"Arş. Gör."}/>
            <InstructorCard name={"Osman"} title={"Arş. Gör."}/>
            <InstructorCard name={"Osman"} title={"Arş. Gör."}/>
            <InstructorCard name={"Osman"} title={"Arş. Gör."}/>
            <InstructorCard name={"Osman"} title={"Arş. Gör."}/> */}
        </div>
    </section>
  )
}

export default Instructors;